export default __webpack_public_path__ + "media/images/ico-psa-members-f3458091f7686b8ee1852a24c13fb19d.svg";